import { Constructor } from 'interfaces/constructor';
import { WCCContentBlock } from '../blocks/block/block';

export function MakeWCCContentBlockWithMerge<TBase extends Constructor<any[], WCCContentBlock>>(Base: TBase) {
    abstract class ExtendedWCCContentBlock extends Base {
        override mergeWith(other: WCCContentBlock) {
            if (this.canMergeWith(other))
                return this.clone({ content: this.content + other.content });

            return super.mergeWith(other);
        }

        private canMergeWith(other: WCCContentBlock) {
            return other != undefined && this.constructor === other.constructor;
        }
    }

    return ExtendedWCCContentBlock;
}